import * as e from "react";
export function useDirection(t, n) {
  const [r, o] = e.useState("ltr"),
    [i, u] = e.useState(),
    c = e.useRef(0);
  return e.useEffect(() => {
    if (void 0 === n && null != t && t.parentElement) {
      const e = getComputedStyle(t.parentElement);
      u(e);
    }
  }, [t, n]), e.useEffect(() => (void 0 === n && function e() {
    c.current = requestAnimationFrame(() => {
      const t = null == i ? void 0 : i.direction;
      t && o(t), e();
    });
  }(), () => cancelAnimationFrame(c.current)), [i, n, o]), n || r;
}